export default "__VITE_ASSET__CfUQlio1__"